<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productLocation.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productLocation.pageTitle'),
            href: '/admin/product-locations',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-4">
              <label class="required">{{
                $t('productLocation.location')
              }}</label>
              <a-select
                v-model="model.location_id"
                :options="locationList"
                mode="multiple"
                showSearch
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                class="ts-w-full ts-mb-3"
              ></a-select>
              <div class="validate" v-if="errors.has('location_id')">
                {{ errors.first('location_id') }}
              </div>
            </div>
          </div>
          <div class="ts-flex ts-space-x-4">
            <div
              class="ts-border ts-border-gray-400 ts-rounded-md ts-w-1/2 ts-p-3"
            >
              <SearchBox v-model="leftSearch" />
              <div class="ts-flex-none max-height min-height">
                <table class="ts-w-full">
                  <thead>
                    <tr>
                      <th
                        class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3 ts-w-3"
                      >
                        <ts-checkbox
                          v-model="leftSideCheckBox"
                          @change="leftProductChange"
                          class="ts--mt-2"
                        ></ts-checkbox>
                      </th>
                      <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                        {{ $t('productLocation.barcode') }}
                      </th>
                      <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                        {{ $t('productLocation.productNameKh') }}
                      </th>
                      <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                        {{ $t('productLocation.productNameEn') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(product, index) in leftProductList"
                      :key="index"
                    >
                      <td class="ts-py-1 ts-px-3 ts-w-3">
                        <ts-checkbox
                          v-model="leftProductListSelected"
                          :value="product.product_id"
                          @change="pickItemLeft"
                          class="ts--mt-2"
                        ></ts-checkbox>
                      </td>
                      <td class="ts-py-1 ts-px-3">{{ product.barcode }}</td>
                      <td class="ts-py-1 ts-px-3">
                        {{ product.product_name_kh }}
                      </td>
                      <td class="ts-py-1 ts-px-3">
                        {{ product.product_name_en }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr>
              <p class="ts-mb-0 ts-mt-3 ts-uppercase ts-font-extrabold"><b>{{ $t('productLocation.total') }}: {{ leftProductList.length }}</b></p>
            </div>
            <div class="ts-flex ts-items-center">
              <div class="ts-h-24 ts-space-y-3 ts-flex-none">
                <button
                  @click.prevent="moveToRight"
                  class="ts-bg-gray-300 ts-px-3 ts-py-1 ts-rounded focus:ts-outline-none"
                >
                  <i class="fas fa-chevron-right"></i>
                </button>
                <br />
                <button
                  @click.prevent="moveLeft"
                  class="ts-bg-gray-300 ts-px-3 ts-py-1 ts-rounded focus:ts-outline-none"
                >
                  <i class="fas fa-chevron-left"></i>
                </button>
              </div>
            </div>
            <div
              class="ts-border ts-border-gray-400 ts-rounded-md ts-w-1/2 ts-p-3"
            >
              <SearchBox v-model="rightSearch" />
              <div class="ts-flex-none max-height min-height">
                <table class="ts-w-full">
                  <thead>
                    <tr>
                      <th
                        class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3 ts-w-3"
                      >
                        <ts-checkbox
                          v-model="rightSideCheckBox"
                          @change="rightProductChange"
                          class="ts--mt-2"
                        ></ts-checkbox>
                      </th>
                      <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                        {{ $t('productLocation.barcode') }}
                      </th>
                      <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                        {{ $t('productLocation.productNameKh') }}
                      </th>
                      <th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
                        {{ $t('productLocation.productNameEn') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(product, index) in productRightSide"
                      :key="index"
                    >
                      <td class="ts-py-1 ts-px-3 ts-w-3">
                        <ts-checkbox
                          v-model="rightProductListSelected"
                          :value="product.product_id"
                          @change="pickItemRight"
                          class="ts--mt-2"
                        ></ts-checkbox>
                      </td>
                      <td class="ts-py-1 ts-px-3">{{ product.barcode }}</td>
                      <td class="ts-py-1 ts-px-3">
                        {{ product.product_name_kh }}
                      </td>
                      <td class="ts-py-1 ts-px-3">
                        {{ product.product_name_en }}
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
              <hr>
              <p class="ts-mb-0 ts-mt-3 ts-uppercase ts-font-extrabold"><b>{{ $t('productLocation.total') }}: {{ model.product_id_list.length }}</b></p>
              <div class="validate" v-if="errors.has('product_id_list')">
                {{ errors.first('product_id_list') }}
              </div>
            </div>
          </div>
          <div class="ts-flex ts-justify-end ts-mt-3 ts-space-x-3 ts-w-full">
            <ts-button
              @click.prevent="$router.push({ name: 'product-location' })"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button
              :waiting="waiting_new"
              @click.prevent="saveAddNew"
              color="primary"
              outline
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              :waiting="waiting"
              @click.prevent="save"
              color="primary"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SearchBox from './components/search-box'
import { Errors } from 'form-backend-validation'
export default {
  components: {
    SearchBox,
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      leftSideCheckBox: false,
      rightSideCheckBox: false,
      productList: [],
      leftProductListSelected: [],
      rightProductListSelected: [],
      leftSearch: {
        text: '',
      },
      rightSearch: {
        text: '',
      },
      model: {
        location_id: [],
        product_id_list: [],
      },
    }
  },
  created() {
    this.loading = true
    this.getLocation().finally(() => {
      this.loading = false
    })
  },
  computed: {
    locationList() {
      return this.$store.state.product.location.locations.map((el) => ({
        value: el.location_id,
        label: el.location_name_en,
      }))
    },
    productRightSide: (vm) => {
      return vm.productList
        .filter((p) => _.includes(vm.model.product_id_list, p.product_id))
        .filter((p) =>
          p.product_name_en
            .toLowerCase()
            .includes(vm.rightSearch.text.toLowerCase()) || p.barcode.toLowerCase().includes(vm.rightSearch.text.toLowerCase())
        )
        .slice(0, 1000)
    },
    countRightProduct() {
      return this.productList.filter((p) =>
        _.includes(this.model.product_id_list, p.product_id)
      ).length
    },
    leftProductList: (vm) => {
      return vm.productList
        .filter((p) => !_.includes(vm.model.product_id_list, p.product_id))
        .filter((p) =>
          p.product_name_en
            .toLowerCase()
            .includes(vm.leftSearch.text.toLowerCase()) || p.barcode.toLowerCase().includes(vm.leftSearch.text.toLowerCase())
        ).slice(0, 1000)
    },
    countLeftProduct() {
      return this.productList.filter(
        (p) => !_.includes(this.model.product_id_list, p.product_id)
      ).length
    },
  },
  methods: {
    ...mapActions('product/location', ['getLocation', 'getProduct', 'store']),
    fetchProduct() {
      this.loading = true
      this.model.product_id_list = []
      this.productList = []
      this.getProduct()
        .then((response) => {
          this.productList = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    moveToRight() {
      this.model.product_id_list.push(...this.leftProductListSelected)
      this.leftProductListSelected = [] // clear product after move to right side
      this.leftSideCheckBox = false // set check all at left to false
    },
    moveLeft() {
      this.model.product_id_list = this.model.product_id_list.filter(
        (value) => !_.includes(this.rightProductListSelected, value)
      )
      this.rightProductListSelected = [] // clear selected at right side product
      this.rightSideCheckBox = false // set check all at right side to false
    },
    leftProductChange(value) {
      if (value) {
        this.leftProductList.map((el) => {
          this.leftProductListSelected.push(el.product_id)
        })
      } else {
        this.leftProductListSelected = []
      }
    },
    rightProductChange(value) {
      if (value) {
        this.model.product_id_list.map((el) => {
          this.rightProductListSelected.push(el)
        })
      } else {
        this.rightProductListSelected = []
      }
    },
    pickItemLeft() {
      this.leftSideCheckBox =
        this.leftProductListSelected.length == this.leftProductList.length
    },
    pickItemRight() {
      this.rightSideCheckBox =
        this.rightProductListSelected.length == this.productRightSide.length
    },
    save() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'product-location' })
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    saveAddNew() {
      this.waiting_new = true
      this.errors = new Errors()
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model.location_id = null
      this.model.product_id_list = []
      this.productList = []
      this.leftSearch.text = ''
      this.rightSearch.text = ''
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchProduct()
    })
  }
}
</script>

<style scoped lang="css">
  table > thead > tr > th {
      position: sticky;
      position: -webkit-sticky;
      top: 0;
      z-index: 999;
  }
  .max-height {
    max-height: 500px;
    overflow-y: scroll;
  }
  .min-height {
    min-height: 500px;
  }
</style>